import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
// import LanguageDetector from 'i18next-browser-languagedetector'

import en from './en/translation'
import ja from './ja/translation'
import vi from './vi/translation'

export const translationsJson = {
  en: {
    translation: en,
  },
  ja: {
    translation: ja,
  },
  vi: {
    translation: vi,
  },
}

export const i18n = i18next
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  // .use(LanguageDetector)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources: translationsJson,
    fallbackLng: 'ja',
    debug:
      import.meta.env.MODE !== 'production' && import.meta.env.MODE !== 'test',

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  })

export default i18next
